import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";

import api from "@/services/api";
import toast from "react-hot-toast";
import Loader from "@/components/Loader";

const StrategyIP = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams();
  const [values, setValues] = useState();

  useEffect(() => {
    fetchData();
  }, [id]);

  const fetchData = async () => {
    try {
      const res = await api.get(`/company/${id}`);
      if (res.ok) {
        if (!res.data.plan) res.data.plan = "certified";
        setValues(res.data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleChange = async () => {
    try {
      const res = await api.put(`/company/${id}`, values);
      if (!res.ok) throw new Error("Une erreur s'est produite lors de la mise à jour de la valeur");
      toast.success("Valeur mise à jour avec succès");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleNext = async () => {
    await handleChange();
    navigate(`../form-strategy-communication`);
  };

  if (!values) return <Loader />;

  return (
    <div className="w-full space-y-8 px-40">
      <div>
        <label className="block text-gray-700 text-sm font-bold mb-2">
          {t("lable.do_u_have_protected_intellectual_property")} <span className="ml-2 text-red-500">*</span>
        </label>
        <div className="flex gap-10 mt-3">
          <div className="flex gap-4 items-center justify-center">
            <input
              type="radio"
              id="intellectual_property_yes"
              name="has_intellectual_properties"
              onChange={() => setValues((prev) => ({ ...prev, has_intellectual_properties: true }))}
              checked={values?.has_intellectual_properties === true}
            />
            <label className="block text-gray-700 text-sm font-bold" htmlFor="intellectual_property_yes">
              {t("yes")}
            </label>
          </div>
          <div className="flex gap-4 items-center justify-center">
            <input
              type="radio"
              id="intellectual_property_no"
              name="has_intellectual_properties"
              onChange={() => setValues((prev) => ({ ...prev, has_intellectual_properties: false }))}
              checked={values?.has_intellectual_properties === false}
            />
            <label className="block text-gray-700 text-sm font-bold" htmlFor="intellectual_property_no">
              {t("no")}
            </label>
          </div>
        </div>
      </div>
      {values.has_intellectual_properties && (
        <div>
          <label className="block text-gray-700 text-sm font-bold mb-2">
            {t("lable.describe_intellectual_property")}
            <span className="ml-2 text-red-500">*</span>
          </label>
          <textarea
            className="input min-h-32"
            placeholder={t("placeholder_enter")}
            value={values?.intellectual_properties || ""}
            onChange={(e) => setValues((prev) => ({ ...prev, intellectual_properties: e.target.value }))}
          />
        </div>
      )}

      <div className="flex justify-between w-full">
        <Link to={`../form-strategy-partnership`} className="empty-button disabled:hover:bg-white px-10">
          {t("previous")}
        </Link>
        <div className="flex items-center gap-2">
          <button className="empty-button disabled:hover:bg-white px-10" onClick={handleChange}>
            {t("save")}
          </button>
          <button className="primary-button disabled:hover:bg-white px-10" onClick={handleNext}>
            {t("next")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StrategyIP;
